// ./gatsby-browser.js
import React from "react"
import { MantineProvider } from "@mantine/core"
import { theme } from "./src/theme"
import "@mantine/core/styles.css"
import "@mantine/carousel/styles.css"
import "./src/styles/variables.css"

export const wrapRootElement = ({ element }) => {
  return <MantineProvider theme={theme}>{element}</MantineProvider>
}
